module.exports = __webpack_public_path__ + "static/media/howitworks.d9eb2abc.png";